import { useEffect, useState } from 'react';
import { useFieldBase } from './useField';
export function usePercentageField(props) {
    // for local field validation
    const [value, setValue] = useState(null);
    // get base props of validation fields
    const [{ value: state, ...baseProps }, saveState] = useFieldBase(props);
    // grab value changes from global state
    useEffect(() => {
        if (state !== undefined)
            setValue(state);
    }, [state, setValue]);
    return {
        ...baseProps,
        onBlur: (value) => value !== null && saveState(value),
        onChange: (value) => setValue(value),
        value,
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationPercentageField = usePercentageField;
